<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.3333 25.3333H6.66667V6.66667H16V4H6.66667C5.95942 4 5.28115 4.28095 4.78105 4.78105C4.28095 5.28115 4 5.95942 4 6.66667V25.3333C4 26.0406 4.28095 26.7189 4.78105 27.219C5.28115 27.719 5.95942 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V16H25.3333V25.3333ZM18.6667 4V6.66667H23.4533L10.3467 19.7733L12.2267 21.6533L25.3333 8.54667V13.3333H28V4H18.6667Z"
      fill="currentColor"
    />
  </svg>
</template>
